module.exports = __webpack_public_path__ + "img/Italian Salad-Chicken.ec2f4da5.jpg";